import { shallow } from "zustand/shallow";
import { createWithEqualityFn } from "zustand/traditional";

type ConfigStoreProps = {
  fees: {
    name: string;
    openFeeP: string;
    closeFeeP: string;
    oracleFeeP: string;
    nftLimitOrderFeeP: string;
    referralFeeP: string;
    minLevPosDai: string;
  }[];
  maxTradesPerPair: number;
};

interface OpenTime {
  [key: string]: {
    timeZone: string;
    openTime: {
      start: string | null;
      end: string | null;
    }[];
    holidays: string[];
    earlyCloses?: {
      date: string | null;
      close: string | null;
    }[];
  };
}

export const openTimeByGroup: OpenTime | any = {
  forex: {
    timeZone: "America/New_York",
    openTime: [
      {
        start: "",
        end: "",
      },
      {
        start: "",
        end: "",
      },
      {
        start: "",
        end: "",
      },
      {
        start: "",
        end: "",
      },
      {
        start: "",
        end: "17:00",
      },
      {
        start: null,
        end: null,
      },
      {
        start: "17:00",
        end: "",
      },
    ],
    holidays: ["25-12", "01-01"],
  },
  "commodities-1": {
    timeZone: "America/New_York",
    openTime: [
      {
        start: "",
        end: "",
      },
      {
        start: "",
        end: "",
      },
      {
        start: "",
        end: "",
      },
      {
        start: "",
        end: "",
      },
      {
        start: "",
        end: "17:00",
      },
      {
        start: null,
        end: null,
      },
      {
        start: "18:00",
        end: "",
      },
    ],
    holidays: ["25-12", "01-01", "29-3"],
  },

  stock: {
    timeZone: "America/New_York",
    openTime: [
      { start: "09:30", end: "16:00" }, // Mon
      { start: "09:30", end: "16:00" }, // Tue
      { start: "09:30", end: "16:00" }, // Wed
      { start: "09:30", end: "16:00" }, // Thu
      { start: "09:30", end: "16:00" }, // Fri
      { start: null, end: null }, // Sat
      { start: null, end: null }, // Sun
    ],
    holidays: [
      "01-01", // New Year's Day
      "20-01", // Martin Luther King Jr. Day
      "17-02", // Presidents' Day
      "18-04", // Good Friday
      "26-05", // Memorial Day
      "19-06", // Juneteenth
      "04-07", // Independence Day
      "01-09", // Labor Day
      "27-11", // Thanksgiving Day
      "25-12", // Christmas Day
    ],
    earlyCloses: [
      { date: "03-07", close: "13:00" }, // Trước Independence Day
      { date: "28-11", close: "13:00" }, // Black Friday
      { date: "24-12", close: "13:00" }, // Christmas Eve
    ],
  },
};

export const useConfigStore = createWithEqualityFn<ConfigStoreProps>(
  () => ({
    fees: [
      {
        name: "crypto",
        openFeeP: "300000000",
        closeFeeP: "600000000",
        oracleFeeP: "1",
        nftLimitOrderFeeP: "200000000",
        referralFeeP: "1",
        minLevPosDai: "150000000000000000000",
        // minLevPosDai: '0',
      },
      {
        name: "forex",
        openFeeP: "30000000",
        closeFeeP: "60000000",
        oracleFeeP: "1",
        nftLimitOrderFeeP: "20000000",
        referralFeeP: "1",
        minLevPosDai: "10000000000000000000000",
        // minLevPosDai: '0',
      },
      {
        name: "commodities-1",
        openFeeP: "37500000",
        closeFeeP: "75000000",
        oracleFeeP: "1",
        nftLimitOrderFeeP: "25000000",
        referralFeeP: "1",
        minLevPosDai: "2500000000000000000000",
        // minLevPosDai: '0',
      },
      {
        name: "Election 2024",
        openFeeP: "1000000000",
        closeFeeP: "2000000000",
        oracleFeeP: "25000000000000000000",
        nftLimitOrderFeeP: "200000000",
        referralFeeP: "1",
        minLevPosDai: "500000000000000000000",
        // minLevPosDai: '0',
      },
      {
        name: "stock",
        openFeeP: "37500000",
        closeFeeP: "75000000",
        oracleFeeP: "1",
        nftLimitOrderFeeP: "25000000",
        referralFeeP: "1",
        minLevPosDai: "500000000000000000000",
        // minLevPosDai: '0',
      },
      {
        name: "stock",
        openFeeP: "37500000",
        closeFeeP: "75000000",
        oracleFeeP: "1",
        nftLimitOrderFeeP: "25000000",
        referralFeeP: "1",
        minLevPosDai: "500000000000000000000",
        // minLevPosDai: '0',
      },
    ],
    maxTradesPerPair: 3,
  }),
  shallow
);
